module.exports = __webpack_public_path__ + "static/media/Weezing_gaussian2.26e0e432.png";